<template>
  <v-col cols="auto">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1000" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition> 
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="primary"
            class="text-capitalize button-shadow mb-3 mb-sm-0"
          >Nova Organização</v-btn>
        </v-fab-transition>
      </template>
      <template>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" class="title" tile elevation="0" dark>Nova Organização</v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="mb-n3">
                  <v-textarea
                    v-model="formulario.nome"
                      label="Nome da Organização"
                      filled
                      rows="2"
                      auto-grow
                      :rules="[v => !!v || 'Nome da Organização é obrigatório.']"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end py-3 mx-1">

              <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
              <v-btn color="primary" type="submit"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>

import {mapActions} from "vuex";

export default {
  components: {},
  props: {
  },
  computed: {
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {}
    };
  },
  created() {
    
  },
  methods: {
    ...mapActions('organizacao', ['criarOrganizacao']),

    save() {
      if(this.$refs.form.validate()) {
        this.create().then((organizacao) => {
          this.$refs.form.resetValidation()
          this.formulario = {};
          this.$emit("save", { organizacao });
          this.fecharELimpar()
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    create() {
      return this.criarOrganizacao(this.formulario);
    },
    fecharELimpar() {
      this.$refs.form.reset()
      this.formulario = {}
      this.dialog = false
    },
  
  },  
};
</script>